import {FC} from 'react';
import {Box, Typography} from '@mui/material';
import {BODY1, H5, DOLLAR} from '@/utils/constants';
import {fundItem} from './fundItem';

interface FundItem {
	donationId: number;
	donaterId: number;
	userName: string;
	donationAmount: number;
}

interface FundItemProps {
	item: FundItem;
}

const FundItem: FC<FundItemProps> = ({item}) => {
	return (
		<Box sx={fundItem.fundItemWrap}>
			<Box>
				<Typography variant={BODY1} sx={fundItem.fundItemLabel}>
					{item.userName}
				</Typography>
				<Typography variant={H5} sx={fundItem.fundItemValue}>
					{DOLLAR}
					{item.donationAmount}
				</Typography>
			</Box>
		</Box>
	);
};

export default FundItem;
